import styled from 'styled-components';

export const ZipCodeInputWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 1.6rem 0;
`;